import React from 'react'
import { TablePlugin } from '../../../../plugins/components/TablePlugin'
import { useGetPathologicalDiseasesQuery } from '../../../../services/rtk-query/clinicalApi'

export const Lista = ({ columns }) => {
  const { data, isFetching } = useGetPathologicalDiseasesQuery({})
  return (
    <>
      <TablePlugin data={data ?? []} columns={columns} isFetching={isFetching} />
    </>
  )
}
